import React, { Component, Fragment } from "react";
import OwlCarousel from 'react-owl-carousel2';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Dialog from '@material-ui/core/Dialog';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import MuiDialogContent from '@material-ui/core/DialogContent';
import ActiveCampaignForm  from './../modals/activeCompaign'

import Header from './Header';
import Footer from './Footer';

const styles = (theme) => ({
    root: {
      margin: 0,
      padding: theme.spacing(2),
    },
    closeButton: {
      position: 'absolute',
      right: theme.spacing(1),
      top: theme.spacing(1),
      color: theme.palette.grey[500],
    },
  });

const DialogTitle = withStyles(styles)(props => {
    const { children, classes, onClose, ...other } = props;
    return (
        <MuiDialogTitle disableTypography className={classes.root} {...other}>
            <Typography variant="h6">{children}</Typography>
            {onClose ? (
                <IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
                    <CloseIcon />
                </IconButton>
            ) : null}
        </MuiDialogTitle>
    );
});

const DialogContent = withStyles(theme => ({
    root: {
        padding: theme.spacing(2),
        width: 600,
        height: 700,
        "@media only screen and (max-width:767px)": {
            maxWidth: 350,
            height: "auto",
            width: "100%",
            minWidth: 250,
            minHeight: 700,
        }
    },
}))(MuiDialogContent);
class FeatureBrandPage extends Component {

    constructor() {
        super()
        this.state = {
            isShowEmailCaptureModal: false
        }
        this.openEmailCaptureModal = this.openEmailCaptureModal.bind(this)
    }

    openEmailCaptureModal() {
        this.setState({ 
            isShowEmailCaptureModal: true 
        })
    }

    render() {

        const options = {
            loop: false,
            nav: true,
            dots: true,
            autoplay: false,
            items: 4,
            navText: [
                "<i class='fa fa-angle-left'></i>",
                "<i class='fa fa-angle-right'></i>"
            ]
        };

        const events = {
            onDragged: function (event) {

            },
            onChanged: function (event) {

            }
        };

        const {isShowEmailCaptureModal} = this.state;

        return (
            <Fragment>

                <Dialog onClose={() => this.setState({ isShowEmailCaptureModal: false })} aria-labelledby="customized-dialog-title" open={isShowEmailCaptureModal}>
                    <DialogTitle id="customized-dialog-title" onClose={() => this.setState({ isShowEmailCaptureModal: false })}>
                        Get you brand featured
                </DialogTitle>
                    <DialogContent dividers>
                        <Typography gutterBottom component="span">
                                <ActiveCampaignForm embedClass={"_form_29"} embedId="29"></ActiveCampaignForm>
                        </Typography>
                    </DialogContent>
                </Dialog>

                <Header {...this.props} />
                <div style={{ 'paddingBottom': '30px' }} id="overview" className="work-list-area default-padding">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-6 thumb text-center">
                                <a href="https://www.pandadoc.com/customers-case-study/"
                                    target="_blank" rel="noopener noreferrer">
                                    <img src="assets/img/featured-brand-main.png"
                                        width="380px" alt="Thumb" /></a>
                            </div>
                            <div className="col-md-6 info text-center">
                                <h3>The only App that features unique Fitness Brands and their creative workouts and training equipment.</h3>
                                <a style={{ 'marginTop': '10px' }}
                                    className="btn circle btn-light border btn-md"
                                    onClick={this.openEmailCaptureModal}>Get your brand featured</a>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="companies-area">
                    <div className="container">
                        <div className="row1">
                            <div className="clearfix"></div>
                            <h3 className="text-center">
                                Save time, money, and energy by letting Fitbanx serve as your personal workout digital platform specific for your brand.
                                </h3>
                            <hr />
                        </div>
                    </div>
                </div>
                <div id="features" className="features-area cell-items default-padding">
                    <div className="container">
                        <div className="row">
                            <div className="features-items icon-solid">
                                <div className="col-md-12">
                                    <div className="items-box inc-cell">
                                        <div className="col-md-4 col-sm-4 equal-height text-center">
                                            <div className="item">
                                                <div className="icon">
                                                    <img width="85px" src="assets/img/content.png" alt="Thumb" />
                                                </div>
                                                <div className="info">
                                                    <h4>Own your content</h4>
                                                    <p>
                                                        Create content easily. You own the content and your customer data. This technology was built for you.
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-4 col-sm-4 equal-height text-center">
                                            <div className="item">
                                                <div className="icon">
                                                    <img width="85px" src="assets/img/income.png" alt="Thumb" />
                                                </div>
                                                <div className="info">
                                                    <h4>Flexible revenue structure</h4>
                                                    <p>
                                                        You decide how and what to charge your customers. Free, price per workout, or subscription...it's your choice.
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-4 col-sm-4 equal-height text-center">
                                            <div className="item">
                                                <div className="icon">
                                                    <img width="85px" src="assets/img/save.png" alt="Thumb" />
                                                </div>
                                                <div className="info">
                                                    <h4>Engage & save time</h4>
                                                    <p>
                                                        Easily connect with customers on their mobile devices WITHOUT wasting time on producing cumbersome internet videos.
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
                <div className="container"><hr /></div>
                <div id="overview" className="work-list-area default-padding">
                    <div className="container">
                        <h1 className="text-center">Meet some of our featured brands</h1>
                        <div className="row">
                            <div className="col-md-6 thumb text-center pull-right">
                                <img src="assets/img/feature-brand-2.png" width="300px" alt="Thumb" />
                            </div>
                            <div className="col-md-6 info pull-left">
                                <h3>Intent Sports</h3>
                                <p>
                                    "Building a high quality app is a major project that we did not want to tackle.  Being in Fitbanx allows us to coach our customers better and provide additional value with our products and it saved us a ton of time and money because we didn’t have to build a quality app ourselves."<br />- Mario Antezana, Founder of Intent Sports
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
                <div style={{ 'paddingTop': 0 }} id="overview" className="work-list-area default-padding">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-6 thumb text-center">
                                <img src="assets/img/feature-brand-4.png" width="400px" alt="Thumb" />
                            </div>
                            <div className="col-md-6 info">
                                <h3>Core Flyte</h3>
                                <p>"We had wanted to build a Core Flyte workout app before but developers were charging an arm and a leg and didn’t offer much customization.  Building our own app just didn’t make sense. By joining forces with other brands inside Fitbanx, we now have a much larger reach and a greater incentive for folks to download and use an app that includes Core Flyte exercises and workouts."<br />-Jeremy Greenberg, Founder of Flyte Fitness</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div style={{ 'paddingTop': 0 }} id="overview" className="work-list-area default-padding">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-6 thumb text-center pull-right">
                                <img src="assets/img/feature-brand-5.png" width="300px" alt="Thumb" />
                            </div>
                            <div className="col-md-6 info  pull-left">
                                <h3>RumbleRoller</h3>
                                <p>
                                    "We had no interest in developing a branded app due to up-front and ongoing development costs. Fitbanx provides us a mobile app solution for our existing users at an unbeatable price point. The Fitbanx platform is so intuitive and simple that you'll spend more time drinking your morning coffee than you will learning how to use Fitbanx to build and share workouts."<br />-Brian Bettendorf, Education Manager of RumbleRoller
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
                <div id="features" className="features-area cell-items default-padding second-page-features sliding-logo">
                    <div className="container">
                        <h1 className="text-center">It’s time for you to enter the digital marketplace and join our winning team of brands</h1>
                        {/* <div className="clients-items owl-carousel owl-theme text-center"> */}
                        <OwlCarousel className="clients-items owl-carousel owl-theme text-center" options={options} events={events} >
                            <div className="single-item" style={{'marginTop': '80px'}}>
                                <a><img src="assets/img/brands/smarter-life.png" alt="Clients" /></a>
                            </div>
                            <div className="single-item">
                                <a><img src="assets/img/brands/body-boss-logo.jpg" alt="Clients" /></a>
                            </div>
                            <div className="single-item">
                                <a><img src="assets/img/brands/core.png" alt="Clients" /></a>
                            </div>
                            <div className="single-item">
                                <a><img src="assets/img/brands/D1.jpg" alt="Clients" /></a>
                            </div>
                            <div className="single-item">
                                <a><img src="assets/img/brands/DStrong.jpg" alt="Clients" /></a>
                            </div>
                            <div className="single-item">
                                <a><img src="assets/img/brands/fit-simplify.png" alt="Clients" /></a>
                            </div>
                            <div className="single-item">
                                <a><img src="assets/img/brands/flyte.jpg" alt="Clients" /></a>
                            </div>
                            <div className="single-item">
                                <a><img src="assets/img/brands/gorilla-bow.png" alt="Clients" /></a>
                            </div>
                            <div className="single-item">
                                <a><img src="assets/img/brands/intent-sports.jpeg" alt="Clients" /></a>
                            </div>
                            <div className="single-item">
                                <a><img src="assets/img/brands/kettle-gryp.png" alt="Clients" /></a>
                            </div>
                            <div className="single-item">
                                <a><img src="assets/img/brands/optp-logo.png" alt="Clients" /></a>
                            </div>
                            <div className="single-item">
                                <a><img src="assets/img/brands/rit-fit.png" alt="Clients" /></a>
                            </div>
                            <div className="single-item">
                                <a><img src="assets/img/brands/rrlogo.png" alt="Clients" /></a>
                            </div>
                            <div className="single-item">
                                <a><img src="assets/img/brands/suples.png" alt="Clients" /></a>
                            </div>
                            <div className="single-item">
                                <a><img src="assets/img/brands/swat-mine.png" alt="Clients" /></a>
                            </div>
                            <div className="single-item">
                                <a><img src="assets/img/brands/tl.png" alt="Clients" /></a>
                            </div>
                            <div className="single-item" style={{ 'marginTop': '80px' }}>
                                <a><img src="assets/img/brands/tribe_fitness.png" alt="Clients" /></a>
                            </div>
                            <div className="single-item">
                                <a><img src="assets/img/brands/valor.png" alt="Clients" /></a>
                            </div>
                        </OwlCarousel>
                    </div>
                </div>
                {/* </div> */}
                <div className="banner-area auto-height text-center text-normal text-light shadow dark-hard bg-fixed featured-last-section">
                    <div className="container">
                        <div className="row">
                            <div style={{ 'padding': '40px 0' }} className="content-box video-popup1">
                                <div className="col-md-10 col-md-offset-1">
                                    <div className="content">
                                        <h2>Enter the digital marketplace with Fitbanx today</h2>
                                        <a className="btn circle btn-light border btn-md" onClick={this.openEmailCaptureModal}>Get your brand featured</a>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
                <Footer {...this.props} />

            </Fragment>
        )
    }
}

export default FeatureBrandPage



// WEBPACK FOOTER //
// ./src/components/FeatureBrandPage.js